document.addEventListener('DOMContentLoaded', function() {
  // Sticky nav
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // Fade up on scroll
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if(e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  // Add to cart button feedback
  document.querySelectorAll('.add-btn, .add-btn-lg').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const orig = this.textContent;
      this.textContent = '✓ Added!';
      this.style.background = '#40916C';
      setTimeout(() => { this.textContent = orig; this.style.background = ''; }, 2000);
    });
  });

  // Email form
  const emailBtn = document.querySelector('.email-form button');
  if (emailBtn) {
    emailBtn.addEventListener('click', function() {
      const input = document.querySelector('.email-form input');
      if (input && input.value.includes('@')) {
        this.textContent = "✓ You're In!";
        this.style.background = '#40916C';
        input.value = '';
        setTimeout(() => { this.textContent = 'Subscribe'; this.style.background = ''; }, 3000);
      }
    });
  }
});
